import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve backend-hosted media (relative /api/media/...) to an absolute URL.
export function mediaUrl(u) {
  if (!u) return u;
  return u.startsWith("http") ? u : `${BACKEND_URL}${u}`;
}

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token as a robust fallback alongside httpOnly cookie.
const stored = typeof window !== "undefined" ? localStorage.getItem("js_token") : null;
if (stored) api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;

export function setToken(token) {
  if (token) {
    localStorage.setItem("js_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("js_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

export function formatApiErrorDetail(detail) {  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
